<template>
  <v-content class="py-5">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-content>
</template>

<script>
export default {
  watch: {
    $route: function(value) {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
